import './Header.scss';
import {Box, Typography} from '@mui/material';
import ArrTooltipWrapper from '../../common/arr-tooltip-wrapper/ArrTooltipWrapper';
import {t} from 'i18next';
import {ReactComponent as InfoIcon} from '../../../assets/images/info-icon.svg';

interface HeaderProps {
  onSaveDraft: () => void;
  isSaving: boolean;
}

const Header: React.FC<HeaderProps> = ({
  onSaveDraft: _onSaveDraft,
  isSaving: _isSaving,
}) => {
  return (
    <>
      {/* 6. Main Page Heading + 7. Info Icon */}
      <Box className="view-ingestion-header" component="header">
        <Box className="view-ingestion-title">
          <Typography
            className="typo-text headline3_size view-ingestion-title-text"
            component="h1"
            id="page-title"
            tabIndex={0}
            data-testid={`header-title`}
          >
            {t('ingestions.Wizard.Title')}
          </Typography>
          <ArrTooltipWrapper
            title={t('ingestions.Wizard.Title')}
            closeTooltipOnEscPress
            trigger={
              <InfoIcon
                fontSize="medium"
                className="view-ingestion-header-info-icon"
                aria-label={t('ingestions.Wizard.ariaLabels.header.infoIcon')}
                tabIndex={0}
              />
            }
          >
            <p tabIndex={0}>
              {t('ingestions.Wizard.infoWizard.overview')}
              {t('ingestions.Wizard.infoWizard.configure')}
            </p>
            <ul data-testid={`header-step1-step2-step3-step4-step5`}>
              <li data-testid={`header-step1`} tabIndex={0}>
                <span data-testid={`header-step1-text`}>
                  {t('ingestions.Wizard.infoWizard.steps.step1')}
                </span>
              </li>
              <li data-testid={`header-step2`} tabIndex={0}>
                {t('ingestions.Wizard.infoWizard.steps.step2')}
              </li>
              <li data-testid={`header-step3`} tabIndex={0}>
                {t('ingestions.Wizard.infoWizard.steps.step3')}
              </li>
              <li data-testid={`header-step4`} tabIndex={0}>
                {t('ingestions.Wizard.infoWizard.steps.step4')}
              </li>
              <li data-testid={`header-step5`} tabIndex={0}>
                {t('ingestions.Wizard.infoWizard.steps.step5')}
              </li>
            </ul>
            <p data-testid={`header-note`} tabIndex={0}>
              {t('ingestions.Wizard.infoWizard.steps.note')}
            </p>
            <p data-testid={`header-status`} tabIndex={0}>
              {t('ingestions.Wizard.infoWizard.steps.status')}
            </p>
          </ArrTooltipWrapper>
        </Box>
      </Box>
      {/* Description text */}
      <Box className="view-ingestionSummary-header">
        <Box className="view-ingestion-title">
          <Typography
            className="typo-text body2_size view-ingestionSummary-title-text"
            id="page-description"
            tabIndex={0}
            onKeyDown={(e: any) => {
              if (e.key === 'Tab' && e.shiftKey) {
                return;
              }
              if (e.key === 'Tab') {
                e.preventDefault();
                (
                  document.querySelector(
                    '[data-testid="save-draft-button"]'
                  ) as HTMLElement
                )?.focus();
              }
            }}
            data-testid={`header-description`}
          >
            {t('ingestions.Wizard.description')}
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default Header;
